import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { homeUrl, onboardingUrl } from 'src/navigation/urls'
import {
  POST_USER_VERIFICATION_SUCCESS,
  postAmplifySignin,
} from 'src/redux/actions/auth.actions'

import { useGetBaseRequestHeaders } from '../shared'

export type AuthConfigResponse = {
  authType: 'password' | 'sso'
  clientId: string | null
  userPoolId: string | null
  identityProviderName: string | null
}

export const useAuthenticateEmail = () => {
  const config = useGetBaseRequestHeaders()

  const mutation = useMutation({
    mutationFn: async (email: string): Promise<AuthConfigResponse> => {
      const resp = await axios.post('/authconfig', { email }, config)

      const configResponse = resp.data as AuthConfigResponse
      return configResponse
    },
  })
  return mutation
}

type UseVerifyMfaChallengeParams = {
  email: string
  code: string
  password?: string
  acceptOrgInvite?: boolean
  suppressRedirect?: boolean
}

export const useVerifyMfaChallenge = () => {
  const config = useGetBaseRequestHeaders()
  const dispatch = useDispatch()
  const history = useHistory()

  const mutation = useMutation({
    mutationFn: async ({
      email,
      code,
      password,
      acceptOrgInvite,
      suppressRedirect,
    }: UseVerifyMfaChallengeParams): Promise<void> => {
      // This is a light refactor of auth.actions.tsx#L2152
      // Code is copied just to keep stuff out of long redux files
      // as we start to move user authentication out of redux
      const resp = await axios.post('/users/verify', { email, code }, config)
      if (password) {
        dispatch(
          postAmplifySignin(email, password, false, false, acceptOrgInvite),
        )
      }
      // TODO: This is following the previous Redux pattern.
      // We need to really break away from this and keep single
      // responsibility principles in here.
      if (!suppressRedirect) {
        if (acceptOrgInvite) {
          history.push(homeUrl())
        } else {
          history.push(onboardingUrl())
        }
      }
      dispatch({
        type: POST_USER_VERIFICATION_SUCCESS,
        payload: resp.data,
      })
    },
  })
  return mutation
}
